import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

export const filterA7OPCVMIssuersSchema = z.object({
  denomination_du_sous_jacent_contains: z.string().optional(),
  lei_contains: z.string().optional(),
  identifiant_fiscal_du_sous_jacent_contains: z.string().optional(),
  secteur_nace_contains: z.string().optional(),
  societe_mere_contains: z.string().optional(),
});

const fields: Field[] = [
  {
    name: "denomination_du_sous_jacent_contains",
    label: "Dénomination",
    type: "input",
  },
  {
    name: "lei_contains",
    label: "LEI",
    type: "input",
  },
  {
    name: "societe_mere_contains",
    label: "Dénomination Société Mère",
    type: "input",
  },
];

export function FilterA7OPCVMIssuers() {
  return (
    <FilterTable
      schema={filterA7OPCVMIssuersSchema}
      tableName="a7_opcvm_issuers"
      fields={fields}
      client="a7"
      customBuildPath={() => `a7-opcvm/a7_opcvm_issuers`}
    />
  );
}
